import { createSlice } from '@reduxjs/toolkit';
import {
  toggleFavoriteThunk,
  fetchFavoritesThunk,
  fetchFavoriteDiscountsDataThunk,
} from './favorties.thunk';
import { FavoritesState } from './favoritesTypes';

const initialState: FavoritesState = {
  favoriteDiscountsIds: [],
  favoriteDiscountsData: [],
  loading: false,
  error: null,
  hasMore: false,
  totalCount: 0,
  isInitialLoad: true,
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    resetFavoritesState: (state) => {
      state.isInitialLoad = true;
      state.hasMore = true;
      state.favoriteDiscountsData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFavoritesThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchFavoritesThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.favoriteDiscountsIds = action.payload;
    });
    builder.addCase(fetchFavoritesThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    builder.addCase(fetchFavoriteDiscountsDataThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchFavoriteDiscountsDataThunk.fulfilled,
      (state, action) => {
        const { data, hasMore } = action.payload;

        if (state.isInitialLoad) {
          state.favoriteDiscountsData = data;
          state.isInitialLoad = false;
        } else {
          const existingIds = new Set(
            state.favoriteDiscountsData.map((d) => d.id),
          );
          const newData = data.filter((d) => !existingIds.has(d.id));
          state.favoriteDiscountsData.push(...newData);
        }

        state.hasMore = hasMore;
        state.loading = false;
      },
    );
    builder.addCase(
      fetchFavoriteDiscountsDataThunk.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      },
    );

    builder.addCase(toggleFavoriteThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toggleFavoriteThunk.fulfilled, (state, action) => {
      state.loading = false;
      const discountId = action.payload;
      if (state.favoriteDiscountsIds.includes(discountId)) {
        state.favoriteDiscountsIds = state.favoriteDiscountsIds.filter(
          (id) => id !== discountId,
        );
        state.favoriteDiscountsData = state.favoriteDiscountsData.filter(
          (d) => d.id !== discountId,
        );
      } else {
        state.favoriteDiscountsIds.push(discountId);
      }
    });
    builder.addCase(toggleFavoriteThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export const { resetFavoritesState } = favoritesSlice.actions;
export default favoritesSlice.reducer;
